<template>
  <div>
    <v-img
      class="d-none d-sm-flex"
      :src="logo"
      height="34"
      max-width="250"
      position="left center"
      contain
    />
    <v-img
      class="d-flex d-sm-none"
      :src="logo"
      height="34"
      max-width="150"
      position="left center"
      contain
    />
  </div>
</template>

<script>
export default {
  name: 'DashLogo',
  props: {
    logo: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>
